export default __webpack_public_path__ + "static/media/bondly-bsc-closed-stub.712e7a7d.svg";